import React, {useEffect, useState} from "react";
import moment from "moment";
import {Box, Grid, Typography} from "@mui/material";
import MembershipStep from "./membershipStep";
import MembershipCards from "./membershipCards";
import ReferralLink from "./refLink";
import Table from "../../components/table/tableHistory";
import AreaChart from "../../components/chart/areaChart";

import pending from "../../assets/images/pending.svg";
import success from "../../assets/images/success.svg";
import failed from "../../assets/images/failed.svg";
import {FileIcon} from "../../assets/svgFile";
import "./dashboard.css";
import {useGetCommissions, useGetRefPerDayInThisWeek} from "../../graphql/graphql/ref/hooks";
import {useVarAuth} from "../../graphql/graphql/auth/defaults";
import LoadingWall from "../../components/loadingWall";
import RefTableHistory from "./refTableHistory";
import RefCrediitTable from "./refCrediitTable";

const chartData = {
  chart: {
    type: "area",
    foreColor: "#ffffffde",
    toolbar: {
      autoSelected: "pan",
      show: false,
    },
  },
  colors: ["#A8A8A8"],
  stroke: {
    width: 2,
  },
  grid: {
    borderColor: "rgba(255, 255, 255, 0.12)",
    clipMarkers: false,
  },
  markers: {
    size: 5,
    colors: ["#fff"],
    strokeColor: "#A8A8A8",
    strokeWidth: 2,
  },
  xaxis: {
    categories: ["Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Sun"],
  },
  yaxis: {
    min: 0,
    // max: 100,
    tickAmount: 4,
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 0.2,
      opacityFrom: 0.5,
      opacityTo: 0.5,
      stops: [0, 50, 100],
    },
  },
  series: [
    {
      type: "area",
      data: [0, 0, 0, 0, 0, 0, 0],
    },
  ],
};

const commissionHeader = ["Type", "Commision", "Email", "Date"];

// const commHistoryData = [
//   {
//     Type: <span className="recurring">Recurring</span>,
//     Commision: "100 credits",
//     Email: "ab***@***.com",
//     Date: "Dec 08, 2022 - 12:53 PM",
//   },
//   {
//     Type: <span className="recurring">Recurring</span>,
//     Commision: "200 credits",
//     Email: "ab***@***.us",
//     Date: "Dec 08, 2022 - 12:53 PM",
//   },
//   {
//     Type: <span className="recurring">Recurring</span>,
//     Commision: "200 credits",
//     Email: "ab***@***.nl",
//     Date: "Dec 08, 2022 - 12:53 PM",
//   },
//   {
//     Type: <span className="recurring">Recurring</span>,
//     Commision: "100 credits",
//     Email: "ab***@***.ru",
//     Date: "Dec 08, 2022 - 12:53 PM",
//   },
//   {
//     Type: <span className="recurring new">New</span>,
//     Commision: "100 credits",
//     Email: "ab***@***.co.uk",
//     Date: "Dec 08, 2022 - 12:53 PM",
//   },
// ];

/*const payoutHeader = ["Type", "Credits Redeemed", "USD", "PayPal Email Address", "Date", "Status"];

const payoutHistoryData = [
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending">
        <img src={pending} alt="status" />
        Pending
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "200 credits",
    USD: "$20.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusSuccess">
        <img src={success} alt="status" />
        Success
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "200 credits",
    USD: "$20.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusSuccess">
        <img src={success} alt="status" />
        Success
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusFailed">
        <img src={failed} alt="status" />
        Failed
      </span>
    ),
  },
  {
    Type: <FileIcon />,
    "Credits Redeemed": "100 credits",
    USD: "$10.00 USD",
    "PayPal Email Address": "paypalemail@email.com",
    Date: "Dec 08, 2022 - 12:53 PM",
    Status: (
      <span className="statusPending statusSuccess">
        <img src={success} alt="status" />
        Success
      </span>
    ),
  },
];*/

const Dashboard = () => {
  const {user} = useVarAuth();
  // const [referralData, setreferralData] = useState([]);
  const [chartsData, setChartsData] = useState(chartData);

  // const date = (date) => {
  //   return creditsPerDay.filter(
  //     (refData) => moment(refData?.Date).format("DD-MM-YYYY") == date
  //   );
  // };

  const datas = [1, 2, 3, 4, 5, 6, 7];
  const {data: getRefPerDayInThisWeek} = useGetRefPerDayInThisWeek();

  useEffect(() => {
    if (getRefPerDayInThisWeek) {
      setChartsData({
        ...chartsData,
        series: [
          {
            ...chartsData.series?.[0],
            data: datas.map(
              (day) =>
                (Object.entries(getRefPerDayInThisWeek).find(([date]) => {
                  //console.log("🚀 ~ file: index.jsx:222 ~ data.creditsPerDay.find ~ date", date);

                  const dayToReturn = moment(date, "YYYY-MM-DD").get("day");
                  //console.log("🚀 ~ file: index.jsx:215 ~ useEffect ~ dayToReturn", dayToReturn);
                  //console.log("🚀 ~ file: index.jsx:212 ~ useEffect ~ day", day);

                  return dayToReturn == day;
                }) || [])[1] || 0
            ),
          },
        ],
      });
    }
  }, [getRefPerDayInThisWeek]);

  // useEffect(() => {
  //   const getFrdHistory = async () => {
  //     try {
  //       const {data} = await axiosClient.get("/user/referral/history");
  //       const tableData = data.map((referral) => ({
  //         Date: moment(referral?.createdAt).format("lll"),
  //         Email: referral?.referralUser?.email,
  //       }));
  //       setreferralFullData(
  //         data.map((referral) => ({
  //           ...referral?.referralUser,
  //           Date: moment(referral?.createdAt).format("lll"),
  //         }))
  //       );
  //       setreferralData(tableData);
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //   };
  //   getFrdHistory();
  // }, []);

  return (
    <Box className="dashboardMain">
      <Box className="dashboardWrap">
        <MembershipStep />
        <Box className="dashboardProfile">
          <Typography variant="h5">Hi, {user?.name}</Typography>
          <Typography mt={1}>
            Welcome back. We think you'll like it here.
          </Typography>
        </Box>
        <MembershipCards />
        <ReferralLink />
        <Box className="chartWrap" pt={1} mb={4}>
          <Typography variant="h5">Referral Progress</Typography>
          <Box className="chartSect">
            <AreaChart chartData={chartsData} />
          </Box>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={5}>
            <RefTableHistory />
          </Grid>
          <Grid item xs={12} lg={7}>
            <RefCrediitTable />
          </Grid>
        </Grid>
      </Box>
      {/* <FooterSubscribe />
      <Footer /> */}
    </Box>
  );
};

export default Dashboard;
